import { styled } from "../../theme/theme";

export const StyledButtonGoogle = styled("img", {
  cursor: "pointer",
  height: 47,
  "@bp2": {
    cursor: "pointer",
    width: "100%",
    height: "100%",
  },
});
